import {createAsyncThunk} from '@reduxjs/toolkit';
import {get} from '../utils/requests';
import {SWFT_DIGITAL_API_HOST} from '../constants';
import {METRICS_ENDPOINT} from 'src/constants/endpoints';

import {
    metricsDataFailure,
    metricsDataRequest,
    metricsDataSuccess,
    metricsWalletDataFailure,
    metricsWalletDataSuccess,
} from 'src/reducers/metrics';
import Tracker from 'src/lib/analytics/tracker';
import {ErrorTags, EventNames} from 'src/lib/analytics/events';

interface GetMetrics {
    org_uid: string;
    timespan_type: number;
}

interface WalletMetrics {
    org_uid: string;
}

enum TimeSpanType {
    LastOneWeek = 1,
    LastThreeWeeks,
    LastOneMonth,
    LastThreeMonths,
}

const getMetrics = createAsyncThunk('metrics/get', async (params: GetMetrics, thunkApi) => {
    try {
        thunkApi.dispatch(metricsDataRequest());
        const data = await get(
            SWFT_DIGITAL_API_HOST +
                METRICS_ENDPOINT +
                '?org_uid=' +
                params.org_uid +
                '&timespan_type=' +
                params.timespan_type,
        );
        Tracker.trackEvent(EventNames.GET_METRICS);
        thunkApi.dispatch(metricsDataSuccess(data));
        return data;
    } catch (e: any) {
        Tracker.trackError(e, ErrorTags.GET_METRICS_ERROR, {
            orgUid: params.org_uid,
            timeSpanType: params.timespan_type,
        });
        thunkApi.dispatch(metricsDataFailure(e));
        throw {failure: 'true'};
    }
});

const getWalletBalance = createAsyncThunk('reward/wallet', async (params: WalletMetrics, thunkApi) => {
    try {
        thunkApi.dispatch(metricsDataRequest());
        const data = await get(SWFT_DIGITAL_API_HOST + '/reward/wallet?org_uid=' + params.org_uid);
        Tracker.trackEvent(EventNames.GET_WALLET_BALANCE);
        thunkApi.dispatch(metricsWalletDataSuccess(data));
        return data;
    } catch (e: any) {
        Tracker.trackError(e, ErrorTags.GET_WALLET_BALANCE_ERROR, {
            orgUid: params.org_uid,
        });
        thunkApi.dispatch(metricsWalletDataFailure(e));
        throw {failure: 'true'};
    }
});

export {getMetrics, getWalletBalance, TimeSpanType};
